import { EOpenAIUserRole, IOpenAICodeGeneratorMessageDTO } from "@kuika/kuika-cl-model";
import { createRef, PureComponent } from "react";
import { OpenAIService } from "../../../../services/openai-service";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { KuikaChatBot } from "../../../common/ai/kuika-chatbot/kuika-chatbot";

interface CustomChatbotProps {
  isChatbotPanelVisible: boolean;
  setIsChatbotPanelVisible: (isChatbotPanelVisible: boolean) => void;
}

interface CustomChatbotState {
  messages: IOpenAICodeGeneratorMessageDTO[];
  isLoading: boolean;
}

class CustomChatbot extends PureComponent<CustomChatbotProps, CustomChatbotState> {
  chatbotMessagesContainerRef = createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      messages: []
    };
  }

  handleScrollToBottom = () => {
    const lastMessage =
      this.chatbotMessagesContainerRef?.current?.children[this.chatbotMessagesContainerRef.current.children.length - 1];

    lastMessage?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  };

  onMessageSend = async (message: string) => {
    try {
      this.setState({ isLoading: true });
      let messages = [...this.state.messages, { content: message, role: EOpenAIUserRole.User }];
      this.setState({ messages }, () => {
        this.handleScrollToBottom();
      });

      const res = await OpenAIService.ChatBot({ messages });

      if (res.status !== 200) return;

      messages = [...this.state.messages, res.data.responseMessage];

      this.setState({ messages }, () => {
        this.handleScrollToBottom();
      });
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    if (this.props.isChatbotPanelVisible === false) return <></>;

    return (
      <div
        style={{
          position: "fixed",
          height: "calc(100vh - 32px)",
          maxHeight: "calc(100vh + 30px)",
          overflow: "hidden",
          top: 0,
          left: 52,
          width: 320,
          zIndex: 1000,
          border: "1px solid var(--control-border)",
          borderRadius: "var(--radius-overlay)",
          boxShadow: "var(--shadow-md)"
        }}
      >
        <KuikaChatBot
          messagesContainerRef={this.chatbotMessagesContainerRef}
          initMessage="Hello, how can I help you with..."
          messages={this.state.messages}
          onMessageSend={this.onMessageSend}
          isLoading={this.state.isLoading}
          inputPlaceholder="Type here"
        />
      </div>
    );
  }
}

export default CustomChatbot;
